import Resource from "shared/actions/resourceActions";

export default class CatalogsResource extends Resource {
  constructor(dispatch, unitId) {
    super(dispatch, "catalog", `/bp/api/v1/sample_units/${unitId}/catalog`);
  }
}
